import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authMe, authLogout, firebaseLogin } from "@/lib/api";
import { socialPulsePopupToken } from "@/lib/firebase";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function login(redirectPath = "/admin") {
  const redirectUrl = window.location.origin + redirectPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
      return u;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await authLogout(); } catch { /* ignore */ }
    setUser(null);
  }, []);

  // Shared SocialPulse (Firebase Google) sign-in — verifies on our backend
  // and establishes the same session cookie the rest of the app uses.
  const signInWithSocialPulse = useCallback(async () => {
    const idToken = await socialPulsePopupToken();
    const u = await firebaseLogin(idToken);
    setUser(u);
    return u;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, setUser, signInWithSocialPulse }}>
      {children}
    </AuthContext.Provider>
  );
}
